var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSelectedRange)?_c('div',{staticClass:"col_click",style:(_vm.styleString)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }